"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobService = void 0;
const typeorm_1 = require("typeorm/browser");
const job_1 = require("./job");
const base_job_service_1 = require("./base-job-service");
const service_1 = require("./service");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
const job_selection_1 = require("./job-selection");
let JobService = class JobService extends base_job_service_1.BaseJobService {
};
JobService.SFID_PREFIX = 'a1w';
JobService.NAME_PREFIX = 'JS';
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        length: 255,
        default: () => 'gid_generate_api_id()',
    }),
    __metadata("design:type", String)
], JobService.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        nullable: true,
        name: 'name',
        length: 80,
        default: () => "gid_generate_name('JS', 6)",
    }),
    __metadata("design:type", String)
], JobService.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'price_purchasing_sum__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "pricePurchasingSum", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'price_selling_sum__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "priceSellingSum", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'price_lists_sum__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "priceListsSum", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'single_purchase_price__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "pricePurchasing", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'single_selling_price__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "priceSelling", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('double precision', {
        name: 'price_lists__c',
    }),
    __metadata("design:type", Number)
], JobService.prototype, "priceLists", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('bool', {
        name: 'is_active__c',
    }),
    __metadata("design:type", Boolean)
], JobService.prototype, "isActive", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => job_1.Job, (job) => job.services),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.JoinColumn)({ name: 'job_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], JobService.prototype, "job", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => service_1.Service),
    (0, typeorm_1.JoinColumn)({ name: 'service__c' }),
    __metadata("design:type", service_1.Service)
], JobService.prototype, "service", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
        name: 'service__c',
    }),
    __metadata("design:type", String)
], JobService.prototype, "serviceSfid", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.CreateDateColumn)({
        nullable: true,
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], JobService.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_selection_1.JobSelection, (selection) => selection.service),
    __metadata("design:type", Array)
], JobService.prototype, "selections", void 0);
JobService = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Job Service',
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('job_service__c', { schema: 'public', synchronize: true })
], JobService);
exports.JobService = JobService;
//# sourceMappingURL=job-service.js.map